// Generated by CoffeeScript 2.7.0
Vue.component('headimg', {
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'tiny'
    },
    extendClass: {
      type: [Object, String, Array]
    }
  },
  template: `<img :src='url' :class='extendClass' class='headimg' />`,
  computed: {
    url: function() {
      return Skylark.Helpers.FileHelper.headimgWithSize(this.src, {
        size: this.size
      });
    }
  }
});
